import { createContext, useContext, type ReactNode } from "react";
import type { MidiasGateway } from "../infrastructure/midias.gateway";

const Ctx = createContext<MidiasGateway | null>(null);

export function ProvedorDeMidias({
  gateway,
  children,
}: {
  readonly gateway: MidiasGateway;
  readonly children: ReactNode;
}) {
  return <Ctx.Provider value={gateway}>{children}</Ctx.Provider>;
}

export function useMidiasGateway(): MidiasGateway {
  const g = useContext(Ctx);
  if (!g) throw new Error("ProvedorDeMidias ausente");
  return g;
}

export function useMidiasGatewayOpcional(): MidiasGateway | null {
  return useContext(Ctx);
}
